<template>
	<div>
		<modalDetail :dialog="dialog" @hideDialog="() => { dialog = false }"></modalDetail>
		<div class="d-flex justify-space-between">
			<div class="text-h5" v-if="$route.name == 'serial-convert'">Penukaran Serial</div>
			<div class="text-h5" v-else>Penukaran Serial Warehouse</div>
		</div>
		<div v-if="loading">
			<loading-card></loading-card>
		</div>
		<div v-if="!loading">
			<v-card class="mt-3" outlined>
				<v-list color="grey lighten-3" class="pa-3">
					<v-list-item dense class="px-1">
						<v-spacer></v-spacer>
						<v-btn text depressed class="primary mr-2" @click="exportData" v-if="false">
							<v-icon>mdi-export</v-icon>
							<div class="pl-2 text-capitalize">Export</div>
						</v-btn>
						<v-btn depressed class="primary" @click="dropfilter = !dropfilter">
							<v-icon>mdi-filter</v-icon>
							<div class="pl-2 text-capitalize">Filter</div>
						</v-btn>
					</v-list-item>
				</v-list>
			</v-card>
			<v-slide-y-transition>
				<v-card outlined class="mt-3" v-if="dropfilter">
					<v-col class="px-4 py-1">
						<v-row>
							<v-col cols="12" md="3">
								<v-text-field dense outlined hide-details label="Kode" v-model="codeConvert.value"></v-text-field>
							</v-col>
							<v-col cols="12" md="3">
								<v-menu v-model="menuDateCreate" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="290px">
									<template v-slot:activator="{ on, attrs }">
										<v-text-field outlined dense :value="convertDate(tanggalDibuat)" label="Tanggal Dibuat" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" hide-details></v-text-field>
									</template>
									<v-date-picker range color="primary" v-model="tanggalDibuat"></v-date-picker>
								</v-menu>
							</v-col>
							<v-col cols="12" md="3">
								<v-autocomplete item-text="" outlined dense hide-details v-model="statusConvert.value" :items="['created', 'approved']" label="Status" no-data-text="Tidak ada data yang sesuai">
									<template v-slot:item = {item}>
										{{item | toStatusConvertSerial}}
									</template>
									<template v-slot:selection = {item}>
										{{item | toStatusConvertSerial}}
									</template>
								</v-autocomplete>
							</v-col>
							<v-col cols="12" md="3">
								<v-text-field dense outlined hide-details label="Kode Pelanggan" v-model="network_code.value"></v-text-field>
							</v-col>
							<v-col cols="12" md="3" v-if="$route.name == 'serial-convert-warehouse'">
								<v-autocomplete item-text="warehouse_name" item-value="warehouse_id" outlined dense hide-details v-model="warehouse.value" :items="warehouseResults" label="Warehouse" no-data-text="Tidak ada data yang sesuai">
								</v-autocomplete>
							</v-col>
							<v-col cols="12" :md="$route.name == 'serial-convert-warehouse' ? 9 : 12" class="text-right">
								<v-btn outlined color="grey darken-1" dark class="text-capitalize" @click="resetFilter">Reset</v-btn>
								<v-btn depressed color="primary" dark class="ml-2 text-capitalize" @click="cari">Cari</v-btn>
							</v-col>
						</v-row>
					</v-col>
				</v-card>
			</v-slide-y-transition>
			<div>
				<v-row class="mr-0" v-if="listSerialConvert.length > 0">
					<v-col cols="12" md="12" class="pb-0 pr-0" v-for="listData in listSerialConvert" :key="listData.serial_convert_id">
						<v-card outlined>
							<v-list color="grey lighten-3" class="pt-0 pb-0">
								<v-list-item dense>
									<v-list-item-content class="grey--text text--darken-2">
										Kode Penukaran Serial {{ listData.serial_convert_code }}
									</v-list-item-content>
								</v-list-item>
							</v-list>
							<v-list-item>
								<v-list-item-content>
									<v-layout wrap>
										<v-flex xs6 sm6 md4>
											<div class="body-2 oppacity-75">Platform</div>
											<div class="subtitle-2 text-uppercase">{{ listData.serial_convert_from }} - {{ listData.serial_convert_type == 'mobile_counter' ? 'MB' : 'GS' }}</div>
											<div class="body-2 pt-3 oppacity-75">Tanggal Dibuat</div>
											<div class="subtitle-2">{{ listData.serial_convert_datetime | tanggaljam }}</div>
										</v-flex>
										<v-flex xs6 sm6 md4>
											<div class="body-2 oppacity-75">Kode Pelanggan</div>
											<div class="subtitle-2">{{ listData.serial_convert_network_code }} - {{listData.customer_name}}</div>
											<div class="body-2 pt-3 oppacity-75">Nomor Handphone</div>
											<div class="subtitle-2">{{ listData.customer_mobilephone }}</div>
										</v-flex>
										<v-flex xs6 sm6 md4>
											<div class="body-2 oppacity-75">Status</div>
											<div class="subtitle-2">
												<span class="mr-2">{{ listData.serial_convert_status | toStatusConvertSerial }}</span>
												<v-tooltip bottom v-if="listData.serial_convert_status == 'created' && userData.user_warehouse_id == listData.serial_convert_warehouse_id">
													<template v-slot:activator="{ on, attrs }">
														<v-btn class="mr-2" fab dark x-small depressed color="teal lighten-2" v-bind="attrs" v-on="on" @click.stop="approve(listData)">
															<v-icon dark>mdi-check</v-icon>
														</v-btn>
													</template>
													<span>Proses</span>
												</v-tooltip>
											</div>
											<div class="pt-4" v-if="$route.name == 'serial-convert-warehouse' && listData.warehouse_name">
												<div class="body-2 oppacity-75">Warehouse</div>
												<div class="subtitle-2">
													<span class="mr-2">{{ listData.warehouse_name }}</span>
												</div>
											</div>
										</v-flex>
									</v-layout>
								</v-list-item-content>
							</v-list-item>
							<div class="pt-2">
								<v-card tile elevation="0">
									<v-data-table :headers="headersProduct" :items="listData.serial_convert_detail" :items-per-page="1000" class="elevation-0 white-row" hide-default-footer>
										<template v-slot:item.serial_convert_detail_from_product_code="{ item }">
											<div>{{ item.serial_convert_detail_from_product_code }}</div>
										</template>
										<template v-slot:item.serial_convert_detail_from_serial="{ item }">
											<div>{{ item.serial_convert_detail_from_serial ? item.serial_convert_detail_from_serial : '-' }}</div>
										</template>
										<template v-slot:item.serial_convert_detail_to_product_code="{ item }">
											<div>{{ item.serial_convert_detail_to_product_code }}</div>
										</template>
										<template v-slot:item.serial_convert_detail_to_serial="{ item }">
											<div>{{ item.serial_convert_detail_to_serial ? item.serial_convert_detail_to_serial : '-' }}</div>
										</template>
									</v-data-table>
								</v-card>
							</div>
						</v-card>
					</v-col>
				</v-row>
			</div>
			<v-card outlined class="mt-3" v-if="listSerialConvert.length == 0 && serialConvertPagination">
				<div class="py-3">
					<not-found></not-found>
				</div>
			</v-card>
			<div class="pt-5">
				<v-row v-if="serialConvertPagination">
					<v-col cols="12" md="11" class="py-0 d-flex justify-end">
						<v-pagination v-model="page" :length="serialConvertPagination.total_page" total-visible="7" circle class="d-flex justify-end no-button-focus" @input="changePage"></v-pagination>
					</v-col>
					<v-col cols="12" md="1" class="py-0 pl-0">
						<v-autocomplete :items="listLimit" v-model="limit" hide-details class="mt-0" label="Item" @input="changeLimit"></v-autocomplete>
					</v-col>
				</v-row>
			</div>
		</div>
	</div>
</template>

<script>
import modalDetail from '@/views/MLwarehouse/sdo/DetailSDO'
import {mapActions,  mapState, mapMutations} from 'vuex'

export default {
	components: {
		modalDetail
	},
	data() {
		return {
			expanded: [],
			dialog: false,
			dropfilter: false,
			menuDateCreate: false,
			loading: true,
			tanggalDibuat: [],
			page: 1,
			limit: "10",
			listLimit: [ '5', '10', '20', '50', '100' ],
			params:[],
			headersProduct: [
			{ text: 'Produk Asal', value: 'serial_convert_detail_from_product_code', sortable: false },
			{ text: 'Serial Asal', value: 'serial_convert_detail_from_serial', sortable: false },
			{ text: 'Produk Tujuan', value: 'serial_convert_detail_to_product_code', sortable: false },
			{ text: 'Serial Tujuan', value: 'serial_convert_detail_to_serial', sortable: false },
			],
			codeConvert: {
				value:'',
				comparison:'like',
				type:'string',
				field: 'serial_convert_code'
			},
			dateSerialConvert: {
				value:'',
				comparison: 'bet',
				type: 'date',
				field: 'serial_convert_datetime'
			},
			statusConvert: {
				value:'',
				comparison: '=',
				type: 'string',
				field: 'serial_convert_status'
			},
			network_code: {
				value:'',
				comparison: 'like',
				type: 'string',
				field: 'serial_convert_network_code'
			},
			warehouse: {
				value:'',
				comparison: '=',
				type: 'string',
				field: 'serial_convert_warehouse_id'
			},
		}
	},
	computed: {
		...mapState('serialConvert', ['listSerialConvert', 'serialConvertPagination']),
        ...mapState('sdo', ['warehouseResults']),
		...mapState('auth', ['userData']),
	},
	methods: {
        ...mapActions('sdo', ['getWarehouseOption']),
		...mapActions('serialConvert', ['getSerialConvert', 'getSerialConvertAll', 'getDetailSerialConvert', 'exportSerialConvert', 'exportSerialConvertAll']),
		...mapMutations('serialConvert', ['clearDataSerialConvert']),
		...mapMutations(['setOverlay']),

		getData() {
			if (this.$route.name == 'serial-convert-warehouse') {
				this.getSerialConvertAll(this.queryString({limit:this.limit, page: this.page, params:this.params, sort: this.sortBy, dir: this.sortDir})).then(() => {
					document.body.scrollTop = 0
					document.documentElement.scrollTop = 0
				})
			} else if (this.$route.name == 'serial-convert') {
				this.getSerialConvert(this.queryString({limit:this.limit, page: this.page, params:this.params, sort: this.sortBy, dir: this.sortDir})).then(() => {
					document.body.scrollTop = 0
					document.documentElement.scrollTop = 0
				})
			}
		},
		changePage(page) {
			this.page = page
			this.getData()
		},
		changeLimit(limit) {
			this.limit = limit
			this.page = 1
			this.getData()
		},
		exportData(){
			if (this.$route.name == 'serial-convert-warehouse') {
				this.exportSerialConvertAll(this.queryString({params:this.params, sort: this.sortBy, dir: this.sortDir}))
			} else if (this.$route.name == 'serial-convert') {
				this.exportSerialConvert(this.queryString({params:this.params, sort: this.sortBy, dir: this.sortDir}))
			}
		},
		cari() {
			this.params = []
			if(this.codeConvert.value)
				this.params.push(this.codeConvert)
			if (this.dateSerialConvert.value) {
				if (this.dateSerialConvert.value.length > 1) {
					this.dateSerialConvert.value.sort()
					let date = this.dateSerialConvert.value.join('::')
					this.dateSerialConvert.value = date
				}
				this.params.push(Object.assign({}, this.dateSerialConvert))
			}
			if (this.statusConvert.value)
				this.params.push(this.statusConvert)
			if (this.network_code.value)
				this.params.push(this.network_code)
			if (this.warehouse.value)
				this.params.push(this.warehouse)

			this.getData()
		},
		resetFilter() {
			this.codeConvert.value = ''
			this.dateSerialConvert.value = ''
			this.tanggalDibuat = []
			this.statusConvert.value = ''
			this.network_code.value = ''
			this.warehouse.value = ''
			this.params = []
			this.limit = 10
			this.getData()
		},
		getDetail(code) {
			this.getDetailSerialConvert(code).then(()=> {
				this.dialog = true
			})
		},
		approve(data) {
            this.$router.push({ name: "approve-serial-convert", params: {code: data.serial_convert_code} })
		},
	},
	async created() {
		await this.$store.dispatch('setPageTitle', `Penukaran Serial`)
		await this.getData()
		await this.getWarehouseOption()
		this.loading = await false
	},
	beforeDestroy() {
		this.clearDataSerialConvert()
	},
	watch: {
		tanggalDibuat(val) {
			this.dateSerialConvert.value = val
		},
		option(val, old) {
			this.sortBy = val.sortBy[0]
			this.sortDir = val.sortDesc[0] ? 'ASC' : 'DESC'
			this.page = 1
			if (this.sortBy || (!this.sortBy && Object.keys(old).length > 0)) {
				this.getData()
			}
		},
		$route() {
			this.resetFilter()
		}
	}
};
</script>